import { FormatMessageType } from '@hooks/useValidation';
import { getPlatformsCodesFromMarks } from '@utils/common.utils';
import { MAX_FIELD, MIN_FIELD, REQUIRED } from '@utils/validation/validation.constant';
import Yup from '@utils/validation/yup-extended';

import { Mark } from '@/types/commons/commons.types';
import { ClassificationEnum } from '@/types/sensor/classification.types';
import { AlertTimeoutThreshold, CommonConfiguration } from '@/types/sensor/sensors';

import { coordinatesSchema } from '../coordinates.schema';

export function commonSensorConfigurationSchemaValidation(
  formatMessage: FormatMessageType,
): Yup.ObjectSchema<Partial<CommonConfiguration>> {
  return Yup.object<Partial<CommonConfiguration>>({
    name: Yup.string().required(formatMessage({ id: REQUIRED })),
    marks: Yup.array().test(
      'at-least-one-platform',
      'At least one platform is required',
      (items: Mark[] | undefined) => getPlatformsCodesFromMarks(items ?? []).length !== 0,
    ),
    sensorAltitude: Yup.number().required(formatMessage({ id: REQUIRED })),
    sensorPosition: coordinatesSchema(formatMessage),
    defaultTargetClassification: Yup.mixed<ClassificationEnum>()
      .oneOf(Object.values(ClassificationEnum), formatMessage({ id: REQUIRED }))
      .required(formatMessage({ id: REQUIRED })),
    timeoutThreshold: Yup.number()
      .required(formatMessage({ id: REQUIRED }))
      .min(0, formatMessage({ id: MIN_FIELD })),
    trackDeleteTime: Yup.number()
      .required(formatMessage({ id: REQUIRED }))
      .min(0, formatMessage({ id: MIN_FIELD })),
    trackLostTime: Yup.number()
      .required(formatMessage({ id: REQUIRED }))
      .min(0, formatMessage({ id: MIN_FIELD })),
    horizontalPrecision: Yup.number()
      .required(formatMessage({ id: REQUIRED }))
      .min(0, formatMessage({ id: MIN_FIELD })),
    verticalPrecision: Yup.number()
      .required(formatMessage({ id: REQUIRED }))
      .min(0, formatMessage({ id: MIN_FIELD })),
  });
}

export function hostSchemaValidation(formatMessage: FormatMessageType): Yup.StringSchema<string> {
  return Yup.string().required(formatMessage({ id: REQUIRED }));
}

export function portSchemaValidation(formatMessage: FormatMessageType): Yup.NumberSchema<number> {
  return Yup.number()
    .required(formatMessage({ id: REQUIRED }))
    .min(0, formatMessage({ id: MIN_FIELD }))
    .max(65535, formatMessage({ id: MAX_FIELD }));
}

export function alertTimeoutThresholdSchemaValidation(
  formatMessage: FormatMessageType,
): Yup.ObjectSchema<AlertTimeoutThreshold> {
  return Yup.object({
    warningNonDetectionTimeoutThreshold: Yup.number()
      .nullable()
      .defined()
      .min(0, formatMessage({ id: MIN_FIELD })),

    nonDetectionTimeoutThreshold: Yup.number()
      .nullable()
      .defined()
      .min(0, formatMessage({ id: MIN_FIELD })),
  });
}
